import { init, CMP, linkVisitorToUser } from "./api";
export type { LinkVisitorToUserOptions } from "./api";
export {
  CMP_STORAGE_KEYS,
  snapshotCmpLocalStorage,
  restoreCmpLocalStorage,
  ensureCmpUserKey,
} from "./core/storage";

// Global API: mevcut CMP ile birleştir (script iki kez yüklenirse üzerine yazma)
const win = window as unknown as { CMP?: typeof CMP; SmartCookie?: typeof CMP };
win.CMP = Object.assign(win.CMP ?? {}, CMP);
win.SmartCookie = win.CMP;

// Auto-initialize when the script loads
const scriptEl = document.currentScript as HTMLScriptElement | null;
const apiBase = scriptEl?.getAttribute("data-api-base") || (window as unknown as { __CMP_API_BASE__?: string }).__CMP_API_BASE__ || "";
const hostnameOverride = scriptEl?.getAttribute("data-hostname") || undefined;

function runInit(): void {
  init(apiBase, hostnameOverride).catch((err) => {
    console.warn("[CMP] Initialization failed; site will continue without banner:", err);
  });
}

// Defer init to avoid blocking LCP (Largest Contentful Paint)
function deferInit(): void {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(() => runInit(), { timeout: 100 });
  } else {
    setTimeout(runInit, 0);
  }
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", deferInit);
} else {
  deferInit();
}

export { CMP, init, linkVisitorToUser };
